import * as types from '../action/actionTypes';

export function closeModalPopUp (data) {
    return {
        type: types.CLOSE_MODAL_POPUP,
        modal_open: data,
    }
}

export function addHoursPeriodModal (data) {
    return {
        type: types.ADD_HOURS_PERIOD_MODAL,
        Data: data,
    }
}

export function ChangeDisplayinFacilities (data) {
    return {
        type: types.CHANGE_VIEW_FACILITY,
        page_to_display: data,
    }
}